/*
 * View containg the response editor.
 * We need to include ckeditorJquery so that we can load the CKEditor, even though we don't
 * use the reference directly
 */

define(["marionette", "./template/topicResponseDeleteCollabDataModalTemplate.html"], function (
  Marionette,
  TopicResponseDeleteCollabDataModalTemplate,
) {
  "use strict";

  const TopicResponseDeleteCollabDataModalView = {};

  TopicResponseDeleteCollabDataModalView.topicResponseDeleteCollabDataModalView =
    Marionette.Layout.extend({
      template: TopicResponseDeleteCollabDataModalTemplate,
      triggers: {
        "click #cancelButton": "cancel",
        "click #deleteButton": "delete:data",
      },
      disableDeleteButton: function () {
        this.$el.find("#deleteButton").prop("disabled", true);
      },
    });

  return TopicResponseDeleteCollabDataModalView;
});
